<script>
    import Mobilebtn2 from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let overlay;
    export let scrollPointers;
    export let updatedValue;

    export let nextPages = false;

    export let image2;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 2, duration: 1},
                {
                    scrollValue: 3,
                    duration: 1,
                    onUpdate: () => {
                        updatedValue = scrollPointers.scrollValue;
                    },
                },
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            overlay,
            [
                {y: 0, duration: 1},
                {y: 0, duration: 1},
            ],
            3,
        );
    }
</script>

<section class="main" bind:this={main} style="">
    <div
        bind:this={overlay}
        class="overlay-wrapper"
        on:scroll={() => {
            nextPages = true;
            image2.style.top = '0vh';
            image2.style.transitionDuration = '1s';
            overlay.scrollTop = 0;
        }}
    >
        <div class="overlay"/>
    </div>
    <div class="backimg">
        <div bind:this={image2} class="img-section-wrapper">
            <div class="white-div">
                <div class="img1">
                    <img
                        src="images/Artist/ArtistMobile/Artist4.png"
                        alt=""
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="text"><p>2</p></div>
            </div>

            <div class="container">
                <div class="div1">
                    <p class="p1">Concept Artists & Illustrators</p>
                </div>
                <div class="div2">
                    <p class="p2">
                        You’re part of an elite tribe whose job is to give birth
                        to imaginary characters, fantastical environments and
                        bring entire worlds into existence. You make fantasy
                        real. <br /><br />
                        <strong>
                            We’re building a platform worthy of your talents and
                            you are invited to the front row seats.</strong
                        >
                    </p>
                </div>
                <div class="div3">
                    <Mobilebtn2
                        width=" 56.308vw"
                        height=" 10.047vw"
                        txtsize="2.336vw"
                        txtsize2="1.869vw"
                        txtcolor="#f4eeec"
                        text2="(Concept Art Seat)"
                        state = "Artists & Musicians"
                    />
                </div>
                <div class="div4">
                    <p class="ar">></p>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .overlay-wrapper{
        position: absolute; 
        height: max(100vh,216vw); 
        width: 100%; 
        overflow: scroll;
    }
    .overlay{
        height: max(102vh,220.32vw); 
        width: 100%;
    }
    .img-section-wrapper {
        height: max(100vh, 216vw);
        overflow: hidden;
        position: relative;
        top: max(100vh, 216vw);
    }
    .backimg {
        background-image: url(images/Artist/ArtistMobile/Artist3.png);
        width: 100%;
        height: max(216.355vw, 100vh);
        background-size: cover;
    }
    .main {
        height: 100%;
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .white-div {
        content: "";
        position: absolute;
        bottom: 0vw;
        left: 0vw;
        height: max(100vh, 216vw);
        width: 100%;
        background-color: white;
        transition: 1s;
        transition-delay: 1s;
    }
    .img1 {
        position: absolute;
        height: max(100vh, 216vw);
    }

    .div2 {
        width: 50.935vw;
        height: max(47.664vw, 22.03vh);
        margin-left: max(9.579vw, 4.428vh);
        margin-bottom: max(10.748vw, 4.968vh);
    }
    .div3 {
        margin: auto;
        margin-bottom: max(7.477vw, 3.456vh);
    }

    .div4 {
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
        margin-bottom: max(7.009vw, 3.24vh);
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: #000000;
        transform: rotate(90deg);
    }
    .div1 {
        width: 70vw;
        margin-left: 9.579vw;
    }

    .p1 {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 7.009vw;
        line-height: 7.009vw;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #000000;
    }

    .p2 {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #000000;
    }
    .container {
        position: absolute;
        bottom: 0vw;
        width: 100%;
        opacity: 1;
        transition-delay: 1.5s;
        transition-duration: 0.8s;
    }
    .text {
        margin-top: max(-7vw, 3.235vh);
    }

    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 140.187vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(244, 238, 236, 0.7);
    }
</style>
